import type { Payment, CalculatedPaymentMetrics } from '../types/payment.types';

export function calculatePaymentMetrics(allPayments: Payment[] = []): CalculatedPaymentMetrics {
  let totalDue = 0;
  let paidThisMonth = 0;
  let pendingApprovals = 0;
  let missingInvoices = 0;

  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  allPayments.forEach((p: Payment) => {
    const amount = Number(p.netPayable) || 0;

    if (p.status === 'pending' || p.status === 'overdue') {
      totalDue += amount;
    }

    if (p.status === 'paid') {
      const paymentDateStr = p.paymentDate || p.createdAt;
      if (paymentDateStr) {
        const paymentDate = new Date(paymentDateStr);
        if (
          paymentDate.getMonth() === currentMonth &&
          paymentDate.getFullYear() === currentYear
        ) {
          paidThisMonth += amount;
        }
      }
    }

    if (p.status === 'pending') {
      pendingApprovals += 1;
    }

    if (!p.hasInvoice && (p.status === 'pending' || p.status === 'overdue')) {
      missingInvoices += 1;
    }
  });

  return {
    totalDue,
    paidThisMonth,
    pendingApprovals,
    missingInvoices,
  };
}

export function isPaymentOverdue(dueDateStr: string | null | undefined, status: string): boolean {
  if (status === 'paid' || status === 'cancelled') return false;
  if (!dueDateStr) return false;
  const dueDate = new Date(dueDateStr);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return dueDate < today;
}
